import styled, { css } from 'styled-components';

export const Wrap = styled.div`
  background-color: #0C1A53;
  padding: 32px 20px 80px 20px;
`;

export const GridWrap = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 16px;
  grid-row-gap: 32px;

  @media only screen and (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const Button = styled.button`
  border: 1px solid #979797;
  color: #222222;
  height: 72px;
  border-radius: 20px;
  padding: 20px 0;
  font-weight: 700;
  font-size: 20px;
  line-height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ checked }) => checked && css`
    border: 2px solid #326CF9;
    background-color: #BAE0FF;
  `}
`;

export const Icon = styled.img`
  width: 44px;
  height: 44px;
  margin-right: 8px;
`;

export const Text = styled.p`
  font-weight: 400;
  font-size: 20px;
  line-height: 22px;
  color: #979797;
  padding-top: 32px;
  text-align: center;
`;
